interface SequenceWithTemplateEditable {
  templateEditable?: boolean;
  [key: string]: unknown;
}

export function isTemplateSupportedForEditing(
  sequence: SequenceWithTemplateEditable | null
): boolean {
  if (!sequence || sequence.templateEditable === undefined) return true;

  return sequence.templateEditable;
}
